import {selectLeaderLevelsInitWaitingMessage} from './../_selectors/leader-level.selectors';
// RxJS
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {select, Store} from '@ngrx/store';
import {AppState} from '../../reducers';
// Selectors
import {selectLeaderLevelsInStore, selectLeaderLevelsPageLoading} from '../_selectors/leader-level.selectors';

export class LeaderLevelsDataSource extends BaseDataSource {
    constructor(private store: Store<AppState>) {
        super();
        this.loading$ = this.store.pipe(
            select(selectLeaderLevelsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectLeaderLevelsInitWaitingMessage)
        );

        this.store.pipe(
            select(selectLeaderLevelsInStore)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });
    }
}
